import type BigNumber from 'bignumber.js';

/** Port of FormattingUtils. Plain functions; there is no service to inject. */

const moneyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 0,
});

const monthNameFormatter = new Intl.DateTimeFormat('en-US', { month: 'long', timeZone: 'UTC' });

export function getCurrencyDisplayClass(value: BigNumber): string {
  return value.isNegative() ? 'money-negative' : 'money-positive';
}

/** Note the original also drops the sign; negatives are shown by colour alone. */
export function getCurrencyString(value: BigNumber): string {
  return moneyFormatter.format(Number(value.absoluteValue().toFixed(0)));
}

export function getHoursAndMinutes(dt: Date): string {
  return dt.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });
}

/** "14:32" -> "2:32 PM" */
export function getTimeFromMilitaryTime(militaryTime: string): string {
  if (!militaryTime) return '';
  const [hoursStr, minutesStr] = militaryTime.split(':');
  const hours = Number(hoursStr);
  return `${hours > 12 ? hours - 12 : hours}:${minutesStr} ${hours > 11 ? 'PM' : 'AM'}`;
}

/**
 * "03" -> "March". The Angular version was a 12-branch if-chain that spelled
 * February as "Februrary"; this is Intl, so the typo is gone.
 */
export function getMonthName(monthNumStr: string): string {
  const monthNum = Number(monthNumStr);
  if (!monthNum || monthNum < 1 || monthNum > 12) return 'unknown';
  return monthNameFormatter.format(new Date(Date.UTC(2000, monthNum - 1, 1)));
}
